import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        flexFlow: "row-wrap",
        border: '1px solid  #cccccc ',
        borderRadius: '20px',                
        position: "relative",
        // width: "100%",
        overflow: "auto",
		margin: '20px 30px 0px 30px',
        padding: '0px'
    },

    root: {
        flexGrow: 1,
    },

    marginBoton:{
        paddingBottom: '10px',
    },

    marginText:{
        paddingLeft: '10px',
        display: 'contents'
    },

    rootLista: {
        width: '100%',
        maxWidth: '100%',
    },

    rootListItem: {
        paddingBottom: '4px',
        paddingTop: '0px',
    },
    colorIcon:{
        color: 'black',
    },

    colorChip:{
        backgroundColor: '#1C4E78',
        color:'white'
    },
    AlignTable:{     
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },    
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
    margenesObservacion:{
        padding: '0px',
        margin: '10px',
    },
	image: {
		width: 70,
		height: 70,
	},
	img: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
	},     
    h1:{
        textAlign: 'center',
        color: '#000',
        fontFamily: 'sans-serif',
        margin: 0,
       '@media (max-width:2000px)':{ // web
            fontSize: '1rem',
        },
       '@media (max-width:1000px)':{ // web
            fontSize: '1rem',
        },
       '@media (max-width:768px)':{ //ipad
            fontSize: '1rem',
        },
       '@media (max-width:415px)':{ //mobile
            fontSize: '1rem',
            marginRight: '10%',
        }
    },      
}))